/**
 * 多个权限任选一个
 * @param perm
 * @return {*}
 */
export const oneOf = (perm: any) => {
  if (!perm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.oneOf(perm);
};

/**
 * 多个权限同时都有
 * @param perm
 * @return {*}
 */
export const allOf = (perm: any) => {
  if (!perm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.allOf(perm);
};

export const combineAndPerm = (oneOfPerm: any, allOfPerm: any) => {
  if (!oneOfPerm) {
    return undefined;
  }
  if (!allOfPerm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.oneOf(oneOfPerm) && loginStatus.allOf(allOfPerm);
};

export const combineOrPerm = (oneOfPerm: any, allOfPerm: any) => {
  if (!oneOfPerm) {
    return undefined;
  }
  if (!allOfPerm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.oneOf(oneOfPerm) || loginStatus.allOf(allOfPerm);
};
